import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { Router, ActivatedRouteSnapshot, NavigationEnd, NavigationError} from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  displayNav: boolean;

  constructor(private titleService: Title, private router: Router,
    private spinner: NgxSpinnerService) {
    this.displayNav = true;
  }

  private getPageTitle(routeSnapshot: ActivatedRouteSnapshot) {
    let title: string = routeSnapshot.data && routeSnapshot.data['pageTitle'] ? routeSnapshot.data['pageTitle'] : 'BSH';
    if (routeSnapshot.firstChild) {
      title = this.getPageTitle(routeSnapshot.firstChild) || title;
    }
    if (title === 'Login' || title === 'Forgot Password' || title === 'Technician Details' || title === 'Reset Password') {
      this.displayNav = false;
    } else {
      this.displayNav = true;
    }
    return title;
  }

  ngOnInit() {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.titleService.setTitle(this.getPageTitle(this.router.routerState.snapshot.root));
      } 
      if (event instanceof NavigationError && event.error.status === 404) {
        this.router.navigate(['/login']);
      }
    });
  }
}
